"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
// checkbox, radio group, switch
var styleOverrides = {
    root: {
        alignItems: 'start',
        '&.Mui-required div': {
            paddingTop: 11
        }
    },
    label: function(param) {
        var theme = param.theme;
        return {
            paddingTop: 11,
            color: theme.palette.text.primary
        };
    }
};
var defaultProps = {
    color: 'inputElements'
};
var _default = exports.default = {
    styleOverrides: styleOverrides,
    defaultProps: defaultProps
}; //# sourceMappingURL=MuiFormControlLabel.js.map
